<form [formGroup]="newDealForm" class="app-page-container">
  <div
    *ngIf="validationErrors.length > 0"
    class="alert alert-danger mb-3"
    data-testid="new-deal-validation-errors"
  >
    <strong>Please fill out the following required fields:</strong>
    <ul class="mb-0 mt-2">
      <li *ngFor="let error of validationErrors">{{ error }}</li>
    </ul>
  </div>

  <h1 class="mb-3" style="line-height: 1">Customer</h1>

  <section formGroupName="customer" data-testid="new-deal-customer-section">
    <div class="row">
      <div class="form-group col-sm-4">
        <label
          [ngClass]="{
          'app-text-danger': touchedInvalid('customer', 'firstName')
        }"
        >
          First Name *
        </label>
        <input
          class="form-control"
          formControlName="firstName"
          data-testid="new-deal-first-name-input"
          type="text"
          autofocus="true"
          [maxlength]="REQS.maxLength.standard"
          (keyup)="cnaService.firstName=this.newDealForm.controls.customer.get('firstName').value"
          (blur)="trimInput('customer', 'firstName', true)"
        />
      </div>

      <div class="form-group col-sm-4">
        <label> Middle Name </label>
        <input
          class="form-control"
          formControlName="middleName"
          data-testid="new-deal-middle-name-input"
          type="text"
          [maxlength]="REQS.maxLength.standard"
          (blur)="trimInput('customer', 'middleName', true)"
        />
      </div>

      <div class="form-group col-sm-4">
        <label [ngClass]="{
          'app-text-danger': touchedInvalid('customer', 'lastName')
        }"
        >
          Last Name *
        </label>
        <input
          class="form-control"
          formControlName="lastName"
          data-testid="new-deal-last-name-input"
          type="text"
          [maxlength]="REQS.maxLength.standard"
          (keyup)="cnaService.lastName=this.newDealForm.controls.customer.get('lastName').value"
          (blur)="trimInput('customer', 'lastName', true)"
        />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-sm-12 col-md-12">
        <label>
          <b>Business Name:</b> Optional.
        </label>
        <input
          class="form-control"
          formControlName="companyName"
          data-testid="new-deal-company-name-input"
          type="text"
          [maxlength]="REQS.maxLength.standard"
        />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-sm-12 col-md-12">
        <label>
          <b>Address Finder:</b> Optional. Start entering an address in the field below to search for an address.
        </label>
        <div style="position: relative;display: flex;justify-content: stretch;align-items: stretch">
          <mat-icon style="position: absolute;top:10px;left:10px;">search</mat-icon>
          <input
            #addressText
            class="form-control"
            type="text"
            style="padding-left: 35px;"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-sm-12 col-md-12">
        <label>
          Street
        </label>
        <input
          class="form-control"
          formControlName="street"
          data-testid="new-deal-street-input"
          type="text"
          [maxlength]="REQS.maxLength.standard"
          (blur)="trimInput('customer', 'street')"
        />
      </div>

      <div class="form-group col-sm-4 col-md-3">
        <label>
          City
        </label>
        <input
          class="form-control"
          formControlName="city"
          data-testid="new-deal-city-input"
          type="text"
          [maxlength]="REQS.maxLength.standard"
          (blur)="trimInput('customer', 'city')"
        />
      </div>

      <div class="form-group col-sm-4 col-md-3">
        <label
          [ngClass]="{
            'app-text-danger': touchedInvalid('customer', 'state')
          }"
        >
          State *
        </label>
        <select
          class="form-control"
          formControlName="state"
          data-testid="new-deal-state-select">
          <option value="">Select State</option>
          <option *ngFor="let state of topStates" [value]="state.code">{{ state.name }}</option>
          <optgroup label="──────────"></optgroup>
          <option *ngFor="let state of otherStates" [value]="state.code">{{ state.name }}</option>
        </select>
      </div>

      <div class="form-group col-sm-4 col-md-3">
        <label
          [ngClass]="{
            'app-text-danger': touchedInvalid('customer', 'county')
          }"
        >
          County *
        </label>
        <input
          #countyInput
          [style.display]="newDealForm.get('customer.state')?.value ==='OR' ? 'none' : 'block'"
          class="form-control"
          formControlName="county"
          data-testid="new-deal-county-input"
          type="text"
          (blur)="trimInput('customer', 'county')"
        />
        <select
          #countySelect
          [style.display]="newDealForm.get('customer.state')?.value ==='OR' ? 'block' : 'none'"
          class="form-control"
          formControlName="county"
          data-testid="new-deal-county-select">
          <option value="">Select County</option>
          <option *ngFor="let county of topORCounties" [value]="county">{{ county }}</option>
          <optgroup label="──────────"></optgroup>
          <option *ngFor="let county of otherORCounties" [value]="county">{{ county }}</option>
        </select>
      </div>

      <div class="form-group col-sm-4 col-md-3">
        <label>
          Zip
        </label>
        <input
          class="form-control"
          formControlName="zip"
          data-testid="new-deal-zip-input"
          type="text"
          inputmode="numeric"
          minlength="5"
          maxlength="5"
          (blur)="trimInput('customer', 'zip')"
        />
      </div>
    </div>

    <div class="row">
      <div class="form-group col-sm-6">
        <label>
          <span>Phone</span>
          <span class="small">
            {{ phoneInput.value.length }} / 10
          </span>
        </label>
        <input
          #phoneInput
          class="form-control"
          formControlName="phone"
          data-testid="new-deal-phone-input"
          type="text"
          inputmode="numeric"
          minlength="10"
          maxlength="10"
          (blur)="trimInput('customer', 'phone')"
        />
      </div>

      <div class="form-group col-sm-6">
        <label>
          Email
        </label>
        <input
          class="form-control"
          formControlName="email"
          data-testid="new-deal-email-input"
          type="email"
          (blur)="trimInput('customer', 'email')"
        />
      </div>
    </div>
  </section>

  <h1 class="mb-3" style="line-height: 1">Vehicle</h1>

  <section formGroupName="vehicle" data-testid="new-deal-vehicle-section">
    <div class="row">
      <div class="form-group col-sm-6">
        <div class="d-flex align-items-start justify-content-between">
          <label
            [ngClass]="{
              'app-text-danger': touchedInvalid('vehicle', 'stockNumber')
            }"
          >
            Stock Number *
          </label>
          <div>
            <button
              *ngIf="!isSalesFloor"
              class="btn rounded-pill px-2 py-0 mx-2"
              [ngClass]="{
                'app-btn-secondary': isDealerTrade,
                'app-btn-success': !isDealerTrade
              }"
              data-testid="new-deal-dealer-trade-btn"
              style="font-size: 0.8rem"
              type="button"
              (click)="toggleDealerTrade()"
            >
              Dealer Trade
            </button>
            <button
              class="btn app-btn-success rounded-pill px-2 py-0"
              style="font-size: 0.8rem"
              type="button"
              [disabled]="isDealerTrade"
              data-testid="new-deal-vehicle-lookup-btn"
              (click)="openVehicleLookup()"
            >
              Lookup
            </button>
          </div>
        </div>
        <input
          class="form-control mb-1"
          formControlName="stockNumber"
          data-testid="new-deal-stock-number-input"
          type="text"
          [maxlength]="REQS.maxLength.standard"
          (blur)="trimInput('vehicle', 'stockNumber')"
          required
        />
      </div>

      <!--  -->

      <ng-container *ngIf="isDealerTrade">
        <div class="form-group col-sm-6">
          <div class="d-flex align-items-start justify-content-between">
            <label>Model Number</label>
            <button
              class="btn app-btn-success rounded-pill px-2 py-0"
              style="font-size: 0.8rem"
              type="button"
              (click)="onSelectModelNumberLookup()"
            >
              Lookup
            </button>
          </div>
          <input
            class="form-control"
            formControlName="modelNumber"
            type="text"
            [maxlength]="REQS.maxLength.standard"
            (blur)="trimInput('vehicle', 'modelNumber')"
          />
        </div>

        <div class="col-sm-6">
          <label
            [ngClass]="{
              'app-text-danger': touchedInvalid('vehicle', 'tradeCondition')
            }"
          >
            Condition
          </label>
          <select class="form-control" formControlName="tradeCondition">
            <option value="">Select Vehicle Condition</option>
            <option value="New">New</option>
            <option value="Certified">Certified</option>
            <option value="Used">Used</option>
          </select>
        </div>

        <div class="form-group col-sm-6">
          <label
            [ngClass]="{
              'app-text-danger': touchedInvalid('vehicle', 'year')
            }"
          >
            Year
          </label>
          <input class="form-control" formControlName="year" type="number"/>
        </div>

        <div class="form-group col-sm-6">
          <label
            [ngClass]="{
              'app-text-danger': touchedInvalid('vehicle', 'make')
            }"
          >
            Make
          </label>
          <input class="form-control" formControlName="make" type="text"/>
        </div>
        <div class="form-group col-sm-6">
          <label
            [ngClass]="{
              'app-text-danger': touchedInvalid('vehicle', 'model')
            }"
          >
            Model
          </label>
          <input class="form-control" formControlName="model" type="text"/>
        </div>
        <div class="form-group col-sm-6">
          <label
            [ngClass]="{
              'app-text-danger': touchedInvalid('vehicle', 'trim')
            }"
          >
            Trim
          </label>
          <input class="form-control" formControlName="trim" type="text"/>
        </div>

        <div class="form-group col-sm-6">
          <label>VIN (Required to Pull Ethos Data)</label>
          <input
            class="form-control"
            formControlName="vin"
            type="text"
            [maxlength]="17"
            (blur)="trimInput('vehicle', 'vin')"
          />
        </div>

        <div class="form-group col-sm-6">
          <label>MSRP</label>
          <input
            class="form-control"
            formControlName="msr"
            type="number"
            [maxlength]="REQS.maxLength.standard"
          />
        </div>

        <div class="form-group col-sm-6">
          <label>Selling Price</label>
          <input
            class="form-control"
            formControlName="retail"
            type="number"
            [maxlength]="REQS.maxLength.standard"
          />
        </div>
      </ng-container>

      <!--  -->

      <div class="form-group col-sm-6">
        <label
          [ngClass]="{
          'app-text-danger': touchedInvalid('vehicle', 'odometer')
        }"
        >
          Odometer
        </label>
        <input
          class="form-control"
          formControlName="odometer"
          data-testid="new-deal-odometer-input"
          inputmode="numeric"
          type="number"
        />
      </div>

      <div class="form-group col-sm-6">
        <label>License Plate</label>
        <input
          class="form-control"
          formControlName="plateNumber"
          data-testid="new-deal-plate-number-input"
          type="text"
          [maxlength]="REQS.maxLength.standard"
          (blur)="trimInput('vehicle', 'plateNumber')"
        />
      </div>

      <div class="form-group col-sm-6">
        <label>Plate Expiration</label>
        <input
          class="form-control"
          formControlName="plateExpires"
          data-testid="new-deal-plate-expires-input"
          type="text"
          [maxlength]="REQS.maxLength.standard"
          (blur)="trimInput('vehicle', 'plateExpires')"
        />
      </div>

      <div class="form-group col-sm-6">
        <label>Sales Person ID</label>
        <input
          class="form-control"
          formControlName="salesId"
          data-testid="new-deal-sales-id-input"
          type="text"
          [maxlength]="REQS.maxLength.standard"
          readonly
        />
      </div>
    </div>
  </section>

  <button
    class="btn app-btn-secondary"
    data-testid="new-deal-continue-btn"
    type="button"
    (click)="onSubmitNewDealForm()"
    [disabled]="uiState.busy"
  >
    <!-- <span
      *ngIf="waitOnAction"
      class="spinner-border spinner-border-sm mr-1"
    ></span> -->
    Continue
  </button>
</form>
